export default {
  BOLETO: 1,
  PIX: 2,
  CREDIT_CARD: 3,
  WALLET: 4,
  SHOPKEEPER_PAYMENT: 5,
};
